import { Icon } from '@chakra-ui/react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const Sliders = ({ children }) => {
  const SlickButtonFix = ({ currentSlide, slideCount, children, ...props }) => <span {...props}>{children}</span>;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    nextArrow: (
      //@ts-ignore
      <SlickButtonFix>
        <Icon
          as={BsChevronRight}
          w={['35px', '35px', '50px']}
          h={['35px', '65px', '50px']}
          color="white"
          zIndex={999999}
        />
      </SlickButtonFix>
    ),
    prevArrow: (
      //@ts-ignore
      <SlickButtonFix>
        <Icon
          as={BsChevronLeft}
          w={['35px', '35px', '50px']}
          h={['35px', '65px', '50px']}
          color="white"
          zIndex={999999}
        />
      </SlickButtonFix>
    ),
  };

  return <Slider {...settings}>{children}</Slider>;
};

export default Sliders;
